import React from "react";
import ConveniosYearPage from "./ConveniosYearPage";
import { convenios2023 } from "../../../../data/Convenios/dataConvenios";

const Convenios2023 = () => <ConveniosYearPage year={2023} data={convenios2023} />;

export default Convenios2023;